/**
 * Created by johanm on 02/10/15.
 */
define('boxes/helpers/signup-render',[''], function () {
	'use strict';

	function setupTermsAndConditions(signupContainerBox) {
		signupContainerBox.$box.find('.terms').find('a').click(function (e) {
			e.preventDefault();
			window.open('/terms/');
		});
	}


	return {
		'setupTermsAndConditions' : setupTermsAndConditions
	};
});

